// extracted by mini-css-extract-plugin
export default {"blob":"App_blob__IKwlh","content":"App_content__wwONY","menu":"App_menu__OMg1Z","menuItem":"App_menuItem__cpkx3","title":"App_title__YS7Xx","floatingBtn":"App_floatingBtn__HnPnc"};